module.exports = __webpack_public_path__ + "img/empty-state-reports.7ffa2164.png";